/*
 * Copyright (c) Baidu, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @file tagLink 组件
 */

import {Component} from 'san';
import type {TagLinkData, TagLinkEvents} from './interface';
import Icon from '@cosui/cosmic/icon';

export default class TagLink extends Component<TagLinkData> {
    static trimWhitespace = 'all';
    static components = {
        'cos-icon': Icon
    };
    static template = `
        <span class="cosd-tag-link">
            <a
                s-bind="linkInfo"
                class="cosd-tag-link-main"
                on-click="handleClick"
            >
                <img
                    s-if="logo"
                    class="cosd-tag-link-logo"
                    src="{{logo}}"
                >
                <cos-icon
                    s-if="!logo && icon"
                    class="cosd-tag-link-icon"
                    name="{{icon}}"
                />
                <span s-if="label">{{label}}</span>
                <span
                    s-if="label"
                    class="cos-divider-vertical-inverse"
                ></span>
                <span
                    s-if="text"
                    class="cos-line-clamp-1"
                >{{text}}</span>
            </a>
        </span>
    `;
    initData(): TagLinkData {
        return {
            linkInfo: {},
            logo: '',
            icon: '',
            label: '',
            text: ''
        };
    }
    handleClick(event: Event) {
        this.fire<TagLinkEvents['click']>('click', event);
    }
}
